export default "__VITE_ASSET__lVXNsulo__"